import { FC, ReactNode } from 'react'
import { useParams } from 'react-router'

import { ExclusionState } from './exclusion.type'
import Loader from 'components/Loader'

import { useGetQuoteV2Query } from 'app/services'
import { ErrorPage } from 'src/Error/ErrorPage'
import { FeatureFlagsProvider, identify, isAcceptedExclusionError } from 'utils'
import { directFlowToken } from 'utils/directFlowToken'
import { isValidApiResponse } from 'utils/error/error'

export const ExclusionWrapper: FC<{ children: (exclusionState: ExclusionState) => ReactNode }> = ({
  children,
}) => {
  const { quoteId } = useParams<{ quoteId: string }>()

  if (!quoteId) {
    throw new Error('Exclusion wrapper used on a route without a quote ID')
  }
  const { error, isFetching } = useGetQuoteV2Query({ quoteId })

  if (isFetching) {
    return <Loader />
  }

  if ((isValidApiResponse(error) && error?.status === 403) || !isAcceptedExclusionError(error)) {
    return <ErrorPage />
  }

  const { email, firstQuoteId, dateOfBirth, postalCode, exclusionCode, vehicleType, channel } =
    error.data.payload
  const isEditedQuote = firstQuoteId !== quoteId
  const exclusionState = {
    quoteId,
    exclusionCode,
    vehicleType,
    firstQuoteId,
    email,
    dateOfBirth,
    postalCode,
    channel,
  }

  identify(quoteId, {
    exclusionCode,
    quoteId,
    firstQuoteId,
  })

  return (
    <FeatureFlagsProvider preQuoteKey={directFlowToken} postQuoteKey={isEditedQuote ? email : ''}>
      {children(exclusionState)}
    </FeatureFlagsProvider>
  )
}
